import API from "../../../utils/helpers/API.helpers";

const FilesService = {
  async uploadFile({ userId, file, prefix, mKSpesialId }) {
    const data = {
      uuid: userId,
      file: file,
      prefix: prefix,
      mk_spesial: mKSpesialId,
    };
    return await API.post({ endpoint: "/file/berkas/", data: data });
  },
  async getFileById(fileId) {
    return await API.getFile({ endpoint: `/file/berkas/${fileId}/` });
  },
  async getFileByName(filename) {
    return await API.getFile({ endpoint: `/file/berkas/get/${filename}/` });
  },
  async getLembarPengesahan(mKSpesialId) {
    return await API.getFile({
      endpoint: `/file/lembar-pengesahan?mk_spesial=${mKSpesialId}`,
    });
  },
  async updateFile({ fileId, userId, filename, mKSpesialId, prefix, file }) {
    const data = {
      nama_file: filename,
      uuid: userId,
      mk_spesial: mKSpesialId,
      file: file,
    };

    if (prefix) {
      data["prefix"] = prefix;
    }
    return await API.put({ endpoint: `/file/berkas/${fileId}`, data: data });
  },
  async deleteFile(fileId) {
    return await API.delete({ endpoint: `/file/berkas/${fileId}/` });
  },
};

export default FilesService;
